import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import {
    addHsn,
    deleteHsn,
    getHsn,
    searchHsn,
    updateHsn,
} from '../../../redux/actions/Master.action';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';

export default function HsnMaster() {
    const [show, setShow] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [ids, setIds] = useState(null);
    const [mainPage, setMainPage] = useState('1');
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        page: '',
        search: '',
    });

    const [initialValues, setInitialValues] = useState({
        hsnCode: '',
        gst: ''
    });

    const validationSchema = Yup.object().shape({
        hsnCode: Yup.string().required('HSN Code is required'),
        gst: Yup.string().required('GST is required'),
    });
    const toggle = () => {
        setShow(!show);
    };
    const updateToggle = () => {
        setUpdateModal(!updateModal);
    };
    const deleteToggle = () => {
        setDeleteModal(!deleteModal);
    };

    const dispatch = useDispatch();
    const hsnData = useSelector((state) => state.master);

    const [formData, setFormData] = useState({
        hsnCode: '',
        gst: '',
        igst: '',
        cgst: '',
        sgst: '',
    });

    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };

    const handleAddHsn = (values, { resetForm }) => {
        dispatch(addHsn(values, limits)).then(() => {
            toggle();
            resetForm();
        });
    };

    const handleUpadteHsn = (values) => {
        const payload = {
            hsnCode: values.hsnCode,
            gst: values.gst,
            igst: values.igst,
            cgst: values.cgst,
            sgst: values.sgst,
        };

        dispatch(updateHsn(payload, limits, ids)).then(() => {
            setUpdateModal(false);
        });
    };

    const handleDeleteHsn = () => {
        dispatch(deleteHsn(ids, limits)).then(() => {
            deleteToggle();
            setMainPage(1);
        });
    };

    const handleSearch = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        const newSearchParams = {
            ...searchDefault,
            search: newSearchQuery || '',
            page: mainPage,
        };
        setSearchDefault(newSearchParams);
        const queryParams = new URLSearchParams(newSearchParams).toString();
        dispatch(searchHsn(queryParams, newSearchParams.page));
    };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
        const updatedSearchParams = {
            ...searchDefault,
            search: searchQuery,
            page: parseInt(selected.selected) + 1,
        };
        setSearchDefault(updatedSearchParams);
        const queryParams = new URLSearchParams(updatedSearchParams).toString();
        dispatch(searchHsn(queryParams, updatedSearchParams.page));
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        hsnData?.getHsn?.data?.totalCount / postPerPage,
    );

    useEffect(() => {
        if (searchQuery) {
            const updatedSearchParams = { ...searchDefault, search: searchQuery, page: mainPage };
            const queryParams = new URLSearchParams(updatedSearchParams).toString();
            dispatch(searchHsn(queryParams, updatedSearchParams.page));
        } else {
            dispatch(getHsn(limits));
        }
    }, [mainPage, rowsPerPage]);

    return (
        <>
            <div className="mt-[100px] d-flex justify-content-end">
                <div className="d-flex items-center gap-3">
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
                        <IoSearchOutline />
                        <input
                            type="text"
                            name="search"
                            value={searchQuery}
                            onChange={handleSearch}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                    <Button
                        onClick={toggle}
                        className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                    >
                        <IoMdAdd className="mt-1 gap-1" />
                        Add HSN
                    </Button>
                </div>
            </div>
            <div className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between mt-5'>
                    <h3 className="fw-bold">HSN Master</h3>
                    <div>
                        Rows per page:
                        <select
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="ms-2 border rounded-md focus:outline-none"
                        >
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </select>
                    </div>
                </div>
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>HSN Code</Th>
                                <Th>GST</Th>
                                <Th>IGST</Th>
                                <Th>CGST</Th>
                                <Th>SGST</Th>
                                <Th className="text-end">Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {hsnData?.getHsn?.data?.data?.length > 0 ? (
                                hsnData?.getHsn?.data?.data?.map((res) => {
                                    return (
                                        <Tr key={res._id}>
                                            <Td>{res.hsnCode}</Td>
                                            <Td>{res.gst}</Td>
                                            <Td>{res.igst}</Td>
                                            <Td>{res.cgst}</Td>
                                            <Td>{res.sgst}</Td>
                                            <Td style={{ minWidth: '200px' }}>
                                                <div className="d-flex gap-3 justify-end">
                                                    <FaEdit
                                                        onClick={() => {
                                                            updateToggle();
                                                            setFormData(res);
                                                            setIds(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-success"
                                                        title="update"
                                                    />
                                                    <MdDelete
                                                        onClick={() => {
                                                            deleteToggle();
                                                            setIds(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-danger"
                                                        title="delete"
                                                    />
                                                </div>
                                            </Td>
                                        </Tr>
                                    );
                                })
                            ) : (
                                <>
                                    <Tr>
                                        <Td colSpan={6} textAlign="center">
                                            Batch Not Found
                                        </Td>
                                    </Tr>
                                </>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>

            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />

            {/* add HSN */}

            <Modal show={show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Add HSN Code</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleAddHsn}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>HSN Code</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="hsnCode"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('hsnCode', e.target.value)
                                                }
                                                value={values.hsnCode}
                                                placeholder="Enter HSN Code"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="hsnCode"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>GST</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="gst"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('gst', e.target.value)
                                                }
                                                value={values.gst}
                                                placeholder="Enter GST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="gst"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>IGST</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="igst"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('igst', e.target.value)
                                                }
                                                value={values.igst}
                                                placeholder="Enter IGST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="igst"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>CGST</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="cgst"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('cgst', e.target.value)
                                                }
                                                value={values.cgst}
                                                placeholder="Enter CGST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="cgst"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>SGST</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="sgst"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('sgst', e.target.value)
                                                }
                                                value={values.sgst}
                                                placeholder="Enter SGST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="sgst"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* update HSN */}

            <Modal show={updateModal} onHide={updateToggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Update HSN Code</Modal.Title>
                </Modal.Header>

                <Formik
                    enableReinitialize={true}
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpadteHsn}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>HSN Code</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="hsnCode"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('hsnCode', e.target.value)
                                                }
                                                value={values.hsnCode}
                                                placeholder="Enter HSN Code"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="hsnCode"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>GST</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="gst"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('gst', e.target.value)
                                                }
                                                value={values.gst}
                                                placeholder="Enter GST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="gst"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>IGST</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="igst"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('igst', e.target.value)
                                                }
                                                value={values.igst}
                                                placeholder="Enter IGST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="igst"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>CGST</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="cgst"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('cgst', e.target.value)
                                                }
                                                value={values.cgst}
                                                placeholder="Enter CGST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="cgst"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>SGST</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="sgst"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('sgst', e.target.value)
                                                }
                                                value={values.sgst}
                                                placeholder="Enter SGST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="sgst"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button type="submit" className="!bg-theme-dark border-0 px-4">
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete HSN */}

            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className="p-5">
                    <div>
                        <PiWarningCircleBold className="text-7xl w-100 text-danger" />
                    </div>
                    <div className="text-center mt-4">
                        <h3>Are You Sure ?</h3>
                        <p className="text-md">
                            Do you really want to delete these records?
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDeleteHsn}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
